import React from 'react';
import { PhoneOff } from 'lucide-react';

const EndCallOverlay = ({ isVisible }) => {
  if (!isVisible) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
      <div className="text-center">
        <div className="inline-block mb-6">
          <div className="w-16 h-16 border-4 border-gray-600 border-t-white rounded-full animate-spin"></div>
        </div>
        <h3 className="text-xl text-white mb-2">Ending call...</h3>
      </div>
    </div>
  )
};

export default EndCallOverlay;